import * as v from "valibot";

// for form fields where empty means null
export const vxNullableInput = () => v.pipe(
    v.unknown(),
    v.transform(s => s === '' || s == null ? null : s)
)

// for form fields where value means number
export const vxNumericInput = () => v.pipe(
    v.union([v.string(), v.number()]),
    v.transform(Number),
    v.finite()
);